(function () {
  function hideExtraParas() {
    document.querySelectorAll('.block-container').forEach(function (el) {
      var next = el.nextElementSibling;
      if (next && next.tagName === 'P') next.style.display = 'none';
    });
  }
  function boot() {
    hideExtraParas();
    if (!window.MutationObserver) return;
    var timer = null;
    new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(hideExtraParas, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
